module.exports = __webpack_public_path__ + "static/img/15.607a01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/15.jpg
// module id = 1KhK
// module chunks = 16